import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Follow, User } from '@app/models';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class FollowService {
  constructor(private http: HttpClient) {}

  deleteBanner(followId, position){
    const data = {
      followId: followId,
      position: position
    }
    return this.http.put<any>(`${API}products/showroom/food/deleteBanner`,data)
  }

  getBanners(followId){
    return this.http.get<any>(`${API}products/showroom/food/banners?FollowId=${followId}`)
  }

  get(options?: any) {
    const opts = options || {};
    let query = Object.keys(opts)
      .map(key => `${key}=${opts[key]}`)
      .join('&');
    query = query ? `?${query}` : '';
    return this.http.get<any>(`${API}follows${query}`);
  }

  getOne(id) {
    return this.http.get<Follow>(`${API}follows/${id}`);
  }

  create(data) {
    return this.http.post<Follow>(`${API}follows`, data);
  }

  getTableCountryBuyer(followId) {
    return this.http.get<any>(`${API}country-buyer-check/${followId}/table-country-buyer`)
  }

  addChargeComplete(followId, countryId, userId) {
    return this.http.post<any>(`${API}country-buyer-check/${followId}`, {followId, countryId, userId})
  }
  
  getCountryBuyerCheck(followId, countryId, userId) {
    return this.http.get<any>(`${API}country-buyer-check?followId=${followId}&countryId=${countryId}&userId=${userId}`)
  }

  update(id, data) {
    return this.http.put<Follow>(`${API}follows/${id}`, data);
  }

  delete(id) {
    return this.http.delete<Follow>(`${API}follows/${id}`);
  }

  getFollowMembers(id) {
    return this.http.get<User[]>(`${API}follows/${id}/members`);
  }

  getFollowMembersByUser(UserId) {
    return this.http.get<User[]>(`${API}follows/${UserId}/member`);
  }

  cancelFollow(followId) {
    return this.http.put<any>(`${API}follows/cancel/${followId}`, {followId})
  }

  updateFollowMember(id, changes) {
    return this.http.put<any>(`${API}follows/${id}/members`, changes);
  }

  removeFollowMembers(id, UserId) {
    return this.http.delete<any>(
      `${API}follows/${id}/members?UserId=${UserId}`
    );
  }

  addFollowMembers(id, UserId) {
    return this.http.post<User>(`${API}follows/${id}/members`, { UserId });
  }

  getSummaryData(id, data) {
    return this.http.get(`${API}follows/${id}/summary?CountryId=${data.countryId}&Businesses=${data.business}`);
  }
  
  changeClpUsd(value, followId) {
    return this.http.post<any>(`${API}follows/change-clp-usd`, {value, followId})
  }

  getShowroomDepartments(data) {
    // code: code,
    // CountryId: CountryId
    let code;

    if (data.code) {
      code = data.code;
    }

    // return this.http.get(`${API}follows/${data.FollowId}/reports/showroom`);

    return this.http.get(
      `${API}follows/${data.FollowId}/reports/showroom?${
        data.code ? 'code=' + data.code : ''
      }${data.CountryId && data.code ? '&CountryId=' + data.CountryId : ''}`
    );
  }

  getSettings(FollowId) {
    return this.http.get(`${API}follows/${FollowId}/settings`);
  }

  search(conditions: any[]) {
    const data = [...conditions];

    return this.http.post<any>(`${API}follows/search`, data);
  }

  searchFollow(conditions: any[]) {
    const data = [...conditions];

    return this.http.post<any>(`${API}follows/search/follows`, data);
  }

  getParents(dataType){
    const query = `year=${dataType.year ? dataType.year : ''}&season=${dataType.season ? dataType.season : ''}&followGroup=${dataType.followGroup ? dataType.followGroup : ''}&type=${dataType.type ? dataType.type : ''}`
    return this.http.get<any>(`${API}follows/Parents?${query}`);
  }

  getBusiCountriesFollows(data){
    const query = `busi=${data.busi ? data.busi : ''}&year=${data.year ? data.year : ''}&milestone=${data.milestone ? data.milestone : ''}&season=${data.season ? data.season : ''}&group=${data.group ? data.group : ''}&department=${data.department ? data.department : ''}`
    return this.http.get<any>(`${API}follows/busiCountries?${query}`)
  }

}
